// front/src/utils/validation.js
import { isValidCpf, isValidCnpj, isValidPhone, isValidCep } from '@brazilian-utils/brazilian-utils';

export const normalizeTelefone = (value) => (value || '').replace(/\D/g, '');

export const required = (value) => {
  if (!value || (typeof value === 'string' && !value.trim())) {
    return 'Este campo é obrigatório';
  }
  return '';
};

export const email = (value) => {
  if (!value) return '';
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(value)) {
    return 'Email inválido';
  }
  return '';
};

export const passwordRequirements =
  'Use no mínimo 8 caracteres, com letra maiúscula, minúscula, número e caractere especial.';

export const password = (value) => {
  if (!value) return '';
  const valid = value.length >= 8 &&
    /[a-z]/.test(value) &&
    /[A-Z]/.test(value) &&
    /[0-9]/.test(value) &&
    /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(value);
  return valid ? '' : passwordRequirements;
};

export const cpf = (value) => {
  if (!value) return '';
  return isValidCpf(value) ? '' : 'CPF inválido';
};

export const cnpj = (value) => {
  if (!value) return '';
  return isValidCnpj(value) ? '' : 'CNPJ inválido';
};

export const minLength = (min) => (value) => {
  if (!value) return '';
  if (value.length < min) {
    return `Mínimo de ${min} caracteres`;
  }
  return '';
};

export const maxLength = (max) => (value) => {
  if (!value) return '';
  if (value.length > max) {
    return `Máximo de ${max} caracteres`;
  }
  return '';
};

export const phone = (value) => {
  if (!value) return '';
  return isValidPhone(value) ? '' : 'Telefone inválido';
};

export const cep = (value) => {
  if (!value) return '';
  return isValidCep(value) ? '' : 'CEP inválido';
};
